import React, { useEffect, useState } from 'react';
import Client from './Client';
import NotClient from './NotClient';

import styles from './OffersPopUp.module.css';

const OffersPopUp = ({ setWindow, popUp, history, merchant }) => {
    const [role, setRole] = useState('public');

    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        setRole(storedUser?.role || 'public');
    }, []);

    return (
        <div className={styles.layout}>
            <img className={styles.logo} src='/Asset/logo.png' alt="DealyGo" />
            <img
                className={styles.close}
                onClick={() => {setWindow(false); window.location.reload();}}
                src='/Navigation/closeIcon.png'
                alt='Fermer'
            />
            {role === 'client' && <Client popUp={popUp} history={history} merchant={merchant} />}
            {role !== 'client' && <NotClient />}
        </div>
    );
};

export default OffersPopUp;
